function refreshStyler() {
    setTimeout(function () {
        $(".js-styler").trigger("refresh");
    }, 100);
}

function jsStyler() {
    if ($(".js-styler").length) {
        $(".js-styler:not(.js-filter)").styler({
            locale: "en",
            selectPlaceholder: "Select...",
            onSelectOpened: function () {
                $(document).trigger("monthPrepare");
                setTimeout(
                    (() => {
                        $(this).addClass("opened");
                        $(this)
                            .find(".jq-selectbox__dropdown")
                            .css("display", "block");
                    }).bind(this),
                    0
                );
            },
            onSelectClosed: function () {
                $(document).trigger("itemSelected");
                if ($(this).hasClass("js-rental-type-select")) {
                    $(document).trigger("rentalTypeSelected");
                }
            },
        });
    }
    if ($(".js-styler.js-filter").length) {
        $(".js-styler.js-filter").styler({
            locale: "en",
            selectSearch: true,
            selectSearchLimit: 10,
            selectSearchPlaceholder: "Enter Keyword",
            onSelectOpened: function () {
                setTimeout(
                    (() => {
                        $(this).addClass("opened");
                        $(this)
                            .find(".jq-selectbox__dropdown")
                            .css("display", "block");
                    }).bind(this),
                    0
                );
            },
            onSelectClosed: function () {
                $(document).trigger("itemSelected");
            },
        });
    }
}

function jsMultiselect() {
    if ($(".js-multiselect").length) {
        $(".js-multiselect").multiselect({
            selectedText: "# out of # selected",
            multiple: true,
            height: 268,
            position: { my: "top+4" },
        });
    }
    if ($(".js-multiselect.js-filter").length) {
        $(".js-multiselect.js-filter")
            .multiselect()
            .multiselectfilter({
                selectedText: "# out of # selected",
                multiple: true,
                height: 268,
                position: { my: "top+4" }
            });
    }
}
